import axios from '@/global-config/request/axios-config';
import schema from "@/global-config/validator/validation-config";
import {useToast} from "vue-toastification";
import ToastificationContent from "@/components/common/ToastificationContent";


export const globalMixin = {
    // setup() {
    //     // Get toast interface
    //     const toast = useToast();
    //
    //     // Use it!
    //     toast("I'm a toast!");
    //
    //     // or with options
    //     toast.success("My toast content", {
    //         timeout: 2000
    //     });
    //     // These options will override the options defined in the "app.use" plugin registration for this specific toast
    //
    //     // Make it available inside methods
    //     return { toast }
    // },
    created() {

    },
    data() {
        return {
            schema,
            successMessage: 'success',
            errorMessage: 'error',
            pendingRequest: false,
            currency: null,
            publicPath: process.env.BASE_URL,
            toastG: useToast(),
            sideBarNav: 'overview'
        }
    },
    methods: {
        baseDecoder(givenString, parseJson = true) {
            var Base64 = {

                // private property
                _keyStr: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=",

                // public method for encoding
                encode: function (input) {
                    var output = "";
                    var chr1, chr2, chr3, enc1, enc2, enc3, enc4;
                    var i = 0;

                    input = Base64._utf8_encode(input);

                    while (i < input.length) {

                        chr1 = input.charCodeAt(i++);
                        chr2 = input.charCodeAt(i++);
                        chr3 = input.charCodeAt(i++);

                        enc1 = chr1 >> 2;
                        enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
                        enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
                        enc4 = chr3 & 63;

                        if (isNaN(chr2)) {
                            enc3 = enc4 = 64;
                        } else if (isNaN(chr3)) {
                            enc4 = 64;
                        }

                        output = output +
                            this._keyStr.charAt(enc1) + this._keyStr.charAt(enc2) +
                            this._keyStr.charAt(enc3) + this._keyStr.charAt(enc4);

                    }

                    return output;
                },

                // public method for decoding
                decode: function (input) {
                    var output = "";
                    var chr1, chr2, chr3;
                    var enc1, enc2, enc3, enc4;
                    var i = 0;

                    input = input.replace(/[^A-Za-z0-9\+\/\=]/g, "");

                    while (i < input.length) {

                        enc1 = this._keyStr.indexOf(input.charAt(i++));
                        enc2 = this._keyStr.indexOf(input.charAt(i++));
                        enc3 = this._keyStr.indexOf(input.charAt(i++));
                        enc4 = this._keyStr.indexOf(input.charAt(i++));

                        chr1 = (enc1 << 2) | (enc2 >> 4);
                        chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
                        chr3 = ((enc3 & 3) << 6) | enc4;

                        output = output + String.fromCharCode(chr1);

                        if (enc3 != 64) {
                            output = output + String.fromCharCode(chr2);
                        }
                        if (enc4 != 64) {
                            output = output + String.fromCharCode(chr3);
                        }

                    }

                    output = Base64._utf8_decode(output);

                    return output;

                },

                // private method for UTF-8 encoding
                _utf8_encode: function (string) {
                    string = string.replace(/\r\n/g, "\n");
                    var utftext = "";

                    for (var n = 0; n < string.length; n++) {

                        var c = string.charCodeAt(n);

                        if (c < 128) {
                            utftext += String.fromCharCode(c);
                        } else if ((c > 127) && (c < 2048)) {
                            utftext += String.fromCharCode((c >> 6) | 192);
                            utftext += String.fromCharCode((c & 63) | 128);
                        } else {
                            utftext += String.fromCharCode((c >> 12) | 224);
                            utftext += String.fromCharCode(((c >> 6) & 63) | 128);
                            utftext += String.fromCharCode((c & 63) | 128);
                        }

                    }

                    return utftext;
                },

                // private method for UTF-8 decoding
                _utf8_decode: function (utftext) {
                    var string = "";
                    var i = 0;
                    var c = 0;
                    var c1 = 0
                    var c2 = 0

                    while (i < utftext.length) {

                        c = utftext.charCodeAt(i);

                        if (c < 128) {
                            string += String.fromCharCode(c);
                            i++;
                        } else if ((c > 191) && (c < 224)) {
                            c2 = utftext.charCodeAt(i + 1);
                            string += String.fromCharCode(((c & 31) << 6) | (c2 & 63));
                            i += 2;
                        } else {
                            c2 = utftext.charCodeAt(i + 1);
                            let c3 = utftext.charCodeAt(i + 2);
                            string += String.fromCharCode(((c & 15) << 12) | ((c2 & 63) << 6) | (c3 & 63));
                            i += 3;
                        }

                    }

                    return string;
                }

            }

            var decoded_string = Base64.decode(givenString);

            if (parseJson) {
                return JSON.parse(decoded_string)
            } else {
                return decoded_string
            }
        },
        copyText(text) {
            // navigator.clipboard.writeText(text);
            // this.toastG({
            //     component: ToastificationContent,
            //     props: {
            //         title: 'Text Copied',
            //         icon: 'BellIcon',
            //         text: text,
            //         variant: 'success',
            //     },
            // })

            if (typeof (navigator.clipboard) == 'undefined') {
                var textArea = document.createElement("textarea");
                textArea.value = text;
                textArea.style.position = "fixed";  //avoid scrolling to bottom
                document.body.appendChild(textArea);
                textArea.focus();
                textArea.select();

                try {
                    var successful = document.execCommand('copy');
                    this.toastG({
                        component: ToastificationContent,
                        props: {
                            title: 'Text Copied',
                            icon: 'BellIcon',
                            text: text,
                            variant: 'success',
                        },
                    })
                } catch (err) {
                    this.toastG({
                        component: ToastificationContent,
                        props: {
                            title: 'Text Copied',
                            icon: 'BellIcon',
                            text: "Error Could not Copy",
                            variant: 'danger',
                        },
                    })
                }

                document.body.removeChild(textArea)
                return;
            }
            navigator.clipboard.writeText(text);
            this.toastG({
                component: ToastificationContent,
                props: {
                    title: 'Text Copied',
                    icon: 'BellIcon',
                    text: text,
                    variant: 'success',
                },
            })

        },
        async makeRequest(requestType = 'get', url, data = {}, optionalConfig = {}, showSuccessMsg = true) {
            // this.toastG.info("I'm an info toast!");
            data.uri = this.endpointMapper(url) ? this.endpointMapper(url) : url

            // for api call in body uri start
            // url = '/'
            // for api call in body uri end

            // direct api call added start
            url = data.uri
            delete data.uri
            // direct api call added end


            /*
            if a request is still pending then the next
            request will not be made to the server until its response is received*/
            if (this.pendingRequest) {
                return;
            }
            let responseFormat = {}
            let requestObj = null;
            switch (requestType) {
                case 'get':

                    requestObj = axios.get(url, data);
                    break;

                case 'post':
                    requestObj = axios.post(url, data, optionalConfig);
                    break;

                case 'put':
                    requestObj = axios.put(url, data, optionalConfig);
                    break;

                case 'delete':
                    requestObj = axios.delete(url, data);
                    break;

                default:
                    /*if no params matches in switch case*/
                    requestObj = axios.get(url, data);

            }

            this.pendingRequest = true;
            await requestObj.then(callResponse => {
                /*success*/
                responseFormat.error = false;
                responseFormat.response = callResponse;
                let code = responseFormat.response.data.code
                if (code == 200) {
                    if (showSuccessMsg)
                        // this.$toast.success(responseFormat.response.data.message);
                        this.toastG({
                            component: ToastificationContent,
                            props: {
                                title: 'Success',
                                icon: 'BellIcon',
                                text: '👋 ' + responseFormat.response.data.message,
                                variant: 'success',
                            },

                        }, {toastClassName: 'badge-glow badge-success'})
                } else if (code == 401) {
                    localStorage.clear();
                    localStorage.setItem('errorMessage', responseFormat.response.data.message);
                    this.$router.push({name: 'payment-failed'})
                    // this.toastG({
                    //     component: ToastificationContent,
                    //     props: {
                    //         title: 'Error',
                    //         icon: 'BellIcon',
                    //         text: '👋 ' + responseFormat.response.data.message,
                    //         variant: 'danger',
                    //     },
                    //
                    // }, {toastClassName: 'badge-glow badge-danger'})
                    // localStorage.clear();
                    // this.$router.push({name: 'send-otp'});
                    return
                } else {
                    localStorage.clear();

                    if (code == 400) {
                        let data  = responseFormat.response.data.data
                        if (data) {
                            if (data.redirectUrl && data.redirectUrl != '' && data.redirectUrl !== null && data.redirectUrl != 'null') {

                                if (responseFormat.response.data.message != '') {
                                    localStorage.setItem('errorMessage', responseFormat.response.data.message);
                                }
                                localStorage.setItem('redirectUrl4', data.redirectUrl);
                                this.$router.push({name: 'payment-failed', query : { redirectUrl4: data.redirectUrl}});
                                return
                            }
                        }
                    }

                    if (responseFormat.response.data.message == '') {
                        localStorage.setItem('errorMessage', 'Error! An error occurred');
                        this.$router.push({name: 'payment-failed'})
                        return
                        // this.$toast.error('Error! An error occurred');
                        // this.toastG({
                        //     component: ToastificationContent,
                        //     props: {
                        //         title: 'Error',
                        //         icon: 'BellIcon',
                        //         text: 'An error occurred',
                        //         variant: 'danger',
                        //     },
                        // }, {toastClassName: 'badge-glow badge-danger'})
                    } else {


                        localStorage.setItem('errorMessage', responseFormat.response.data.message);
                        this.$router.push({name: 'payment-failed'})
                        return
                        // this.$toast.error(responseFormat.response.data.message);
                        // this.toastG({
                        //     component: ToastificationContent,
                        //     props: {
                        //         title: 'Error',
                        //         icon: 'BellIcon',
                        //         text: '👋 ' + responseFormat.response.data.message,
                        //         variant: 'danger',
                        //     },
                        //
                        // }, {toastClassName: 'badge-glow badge-danger'})
                    }
                }

            }).catch(error => {
                /*error*/
                responseFormat.error = true;
                responseFormat.response = error;

                localStorage.setItem('errorMessage', error.response.data.message);
                this.$router.push({name: 'payment-failed'})

                // this.$toast.error('Error! An error occurred');
                // this.toastG({
                //     component: ToastificationContent,
                //     props: {
                //         title: 'Error',
                //         icon: 'BellIcon',
                //         text: '👋 An error occurred',
                //         variant: 'danger',
                //     },
                // })
            }).finally(() => {
                this.pendingRequest = false;

            });


            return responseFormat;
        },
        endpointMapper(uri) {
            let uris = {}

            if (typeof (uris[uri]) != 'undefined')
                return uris[uri]
            else
                return null

        },
        redirect(url) {
            window.location.replace(url)
            return
        },
    },
    watch: {
        sideBarNav() {

        }
    }
}
